module.exports = __webpack_public_path__ + "img/02.a1a9cf81.jpg";